"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _locals = _interopRequireDefault(require("../locals"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkLang = function checkLang(lang) {
  var _locals$available;

  if ((_locals.default === null || _locals.default === void 0 ? void 0 : (_locals$available = _locals.default.available) === null || _locals$available === void 0 ? void 0 : _locals$available.indexOf(lang)) === -1) return _locals.default === null || _locals.default === void 0 ? void 0 : _locals.default.available[0];
  return lang;
};

var _default = checkLang;
exports.default = _default;